import React, {Fragment} from 'react';
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import SelectorCalendar from "../../../form/SelectorGrid/SelectorCalendar";
import moment from 'moment';
import Select from "../../../form/Select";

class EventCalendar extends React.Component {

    state = {
        programs: [],
        locations: []
    }

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {
            componentConfig,
            filter,
            loading: isLoading,
            pageSize: 0// important for SelectorCalendar
        };
        if (view) {
            props.view = view;
        }
        let subFilter = null;
        if (this.state.programs.length && this.state.locations.length) {
            subFilter = [{filters: [{field: "program", value: this.state.programs, operator: "in"}, {field: "locations", value: this.state.programs, operator: "in"}], operator: "or"}];
        } else if (this.state.programs.length) {
            subFilter = [{field: "program", value: this.state.programs, operator: "in"}];
        } else if (this.state.locations.length) {
            subFilter = [{field: "locations", value: this.state.locations, operator: "in"}];
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-6">
                        <Select
                            component="Program"
                            name="programs"
                            value={this.state.programs}
                            label="Program(ok)"
                            labelKey="name"
                            isMulti={true}
                            objectValue={false}
                            saveChanges={(field, value) => {
                                this.setState({
                                    [field]: value
                                });
                            }}
                        />
                    </div>
                    <div className="col-md-6">
                        <Select
                            component="location"
                            name="locations"
                            value={this.state.locations}
                            label="Helszín(ek)"
                            labelKey="name"
                            isMulti={true}
                            objectValue={false}
                            saveChanges={(field, value) => {
                                this.setState({
                                    [field]: value
                                });
                            }}
                        />
                    </div>
                </div>
                <SelectorGrid
                    type={SelectorCalendar}
                    ref={(el) => this.list = el}
                    gridid={this.props.gridid !== undefined ? this.props.gridid : "EventCalendar"}
                    exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", addFilters: true}]}
                    {...props}
                    filter={subFilter}
                    formatRows={(items) => {
                        return items.map((item) => {
                            item.editable = false;
                            item.title = item.program.name + " - " + (item.locations || []).map((location) => location.name).join(", ");
                            item.start = moment(item.from, "YYYY-MM-DD HH:mm:ss").toDate();
                            item.end = moment(item.to, "YYYY-MM-DD HH:mm:ss").toDate();
                            return item;
                        })
                    }}
                    rowClassName={(rowData) => {
                        return {
                            "label": true,
                            "label-default": !parseInt(rowData.canceled || 0) && !parseInt(rowData.public || 0),
                            "label-primary": !parseInt(rowData.canceled || 0) && !!parseInt(rowData.public || 0),
                            "label-warning": !!parseInt(rowData.canceled || 0)
                        };
                    }}
                    view={["canceled", "public"]}
                    columns={{
                        "id": {header: 'Kód', width: 1, sortable, filterable},
                        "program.name": {header: 'Program', width: 2, sortable, filterable},
                        "from": {header: 'Időtartam', width: 3, sortable, filterable},
                        "to": {header: 'Időtartam', width: 3, sortable, filterable},
                        "locations": {header: 'Hely', width: 2, renderer: (locations) => (locations || []).map((location) => location.name).join(", ")},
                    }}
                    onPage={(paging) => {
                        paging.filters = {
                            "from": {value: moment(paging.start).format("YYYY-MM-DD"), operator: ">"},
                            "to": {value: moment(paging.end).format("YYYY-MM-DD"), operator: "<"}
                        };
                        return paging;
                    }}
                    orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                    selection={selection}
                    onSelectionChange={(selection) => this.props.loadForm(selection.value)}
                />
            </Fragment>
        );
    }
}

export default EventCalendar;
